<template>
  <div class="depositorResults flex flex-col h-full">
    <div class="w-full h-full flex-1 flex flex-col items-center text-white">
      <template v-if="status === 'Paying'">
        <van-loading class="mt-[80px]" />
        <span class="text-[12px] leading-[14px] text-[#95979b] mt-[45px]">
          {{ $t("DepositoResults.OrderNumber") }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ searchParams.orderNo }}
        </span>
        <div class="text-[20px] mt-[15px] mb-[10px]">
          {{ $t("DepositoResults.OrderQuery") }}
        </div>
        <div class="text-[14px] text-center px-[60px] leading-[16px]">
          {{ $t("DepositoResults.WaitingForResults") }}
        </div>
      </template>
      <template v-else-if="status === 'TryAgain'">
        <Image class="w-[200px] h-[100px] mt-[80px]" :src="overtime" alt="" />
        <span class="text-[12px] leading-[14px] text-[#95979b] mt-[45px]">
          {{ $t("DepositoResults.OrderNumber") }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ searchParams.orderNo }}
        </span>
        <div class="text-[15px] mt-[15px] mb-[10px]">
          {{ $t("DepositoResults.NoResults") }}
        </div>
        <div class="text-[12px] text-center px-[50px] leading-[16px]">
          {{ $t("DepositoResults.TryAgainMessage") }}
        </div>
        <button
          @click="retryQuery"
          class="h-[44px] text-[15px] mt-[30px] primaryBtn !w-[356px]"
        >
          {{ $t("DepositoResults.RetryQuery") }}
        </button>
      </template>
      <template v-else-if="status === 'Paid' || status === 'ForcedSuccess'">
        <div class="mt-[80px] bgs-[var(--deposit-success-bg)] w-[58px] h-[58px]" />
        <span class="hilight text-[var(--theme-gray100)] text-[25px] font-bold mt-[20px]">
          {{ $t("DepositoResults.Amount") }} {{ formatter().format(amount) }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ $t("DepositoResults.OrderNumber") }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ searchParams.orderNo }}
        </span>
        <div class="text-[20px] mt-[15px] mb-[10px]">
          {{ $t("DepositoResults.DepositSuccessful") }}
        </div>
        <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
          {{ $t("DepositoResults.ReturnToHomeMessage") }}
        </div>
        <button
          @click="navigateHome"
          class="h-[44px] text-[15px] mt-[30px] primaryBtn !w-[356px]"
        >
          {{ $t("DepositoResults.ReturnToHome") }}
        </button>
      </template>
      <template v-else-if="status === 'PayFailed' || status === 'ForcedFailed'">
        <Image class="size-[58px] mt-[80px]" :src="fail" alt="" />
        <span class="hilight text-[var(--theme-gray100)] text-[25px] font-bold mt-[20px]">
          {{ $t("DepositoResults.Amount") }} {{ formatter().format(amount) }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ $t("DepositoResults.OrderNumber") }}
        </span>
        <span class="text-[12px] leading-[14px] text-[#95979b]">
          {{ searchParams.orderNo }}
        </span>
        <div class="text-[20px] mt-[15px] mb-[10px]">
          {{ $t("DepositoResults.DepositFailed") }}
        </div>
        <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
          {{ $t("DepositoResults.ReturnToHomeMessage") }}
        </div>
        <button
          @click="navigateHome"
          class="!h-[44px] text-[15px] mt-[30px] primaryBtn !w-[356px]"
        >
          {{ $t("DepositoResults.ReturnToHome") }}
        </button>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import overtime from "@/views/DepositoResults/images/overtime.png";
import fail from "@/views/DepositoResults/images/fail.png";
import { formatter } from "@/utils";
import { checkingOrder } from "@/api/deposito";
import { useActivityList, useWallet } from "@/store";
import { useGameFlowStore } from "@/store";
const flowStore = useGameFlowStore();
// import useTrack from "@/hooks/useTrack";

// const { track2Platform, trackName } = useTrack();
const route = useRoute();
const router = useRouter();
const status = ref("Paying");
const amount = ref<any>(0);
const searchParams = ref<any>({});
const orderNo = ref("");
const maxRetries = 4;
let attempt = 0;
let tid;
const props = defineProps({
  flowData: {
    type: Object,
    default: () => ({}),
  },
});

onMounted(() => {
  if (router.currentRoute.value.path.includes("game")) {
    searchParams.value = props.flowData;
    orderNo.value = searchParams.value.orderNo;
  } else {
    searchParams.value = route.query;
    orderNo.value = searchParams.value.orderNo;
  }

  if (searchParams.value.status == "PullFailed") {
    status.value = "PayFailed";
    amount.value = searchParams.value.amount;
  } else {
    clearInterval(tid);
    queryOrderState();
  }
});

const queryOrderState = async () => {
  const res = await checkingOrder({ orderNo: orderNo.value });
  console.log(res, attempt);

  if (
    res?.data?.status === "ForcedSuccess" ||
    res?.data?.status === "ForcedFailed" ||
    res?.data?.status === "Paid" ||
    res?.data?.status === "PayFailed"
  ) {
    amount.value = res?.data?.realAmt;
    status.value = res?.data?.status;

    if (
      res?.data?.status !== "PayFailed" && res?.data?.status !== "ForcedFailed"
    ) {
      useWallet().init();
    }

    return;
  }

  if (attempt === 3) {
    status.value = "TryAgain";
  }

  attempt++;
  if (attempt < maxRetries) {
    tid = setTimeout(() => {
      queryOrderState();
    }, 3000);
  }
};
// 重试查询
const retryQuery = async () => {
  status.value = "Paying";
  clearInterval(tid);
  queryOrderState();
};
const navigateHome = () => {
  if (router.currentRoute.value.path.includes("game")) {
      flowStore.hide()
  } else {
    router.push("/");
  }
  if (status.value === "Paid") {
    setTimeout(() => {
      useActivityList().init();
    }, 20000);
  }
};
defineExpose({
  navigateHome,
});
</script>

<style scoped></style>
